import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';



import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';


@Component({
  selector: 'app-app-route-billing-items-grid',
  templateUrl: './app-route-billing-items-grid.component.html',
  styleUrls: ['./app-route-billing-items-grid.component.scss']
})
export class AppRouteBillingItemsGridComponent implements OnInit {

  @Input() app_route_id; 
  @Input() subject_id; 
  @Input() brand_id?: Observable<any[]>; 
  @Input() job_status_code?: Observable<any[]>; 
  @Input() assigned_agent?: Observable<any[]>;  // single agent brand_id lookup
  
  
     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes. // Base set to Job_ID
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = null;
     @Input() item_brand_id? = null;
     @Input() item_subject_id? = null;
     @Input() item_subject_number? = '';
     
     @Input() show_buttons? = 'no'; // yes | no
     @Input() item_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  

     @Input() job_id; 
     @Input() current_job_invoice_couunt;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
 

 // Grid Vars
 public data: DataManager;
 public data_subjects: DataManager;
 public pageSettings: Object;
 public pageOptions = { pageSize: 100 }; 
 public filterOptions: FilterSettingsModel;
 public formatOptions: Object;
 // public filterOptions: FilterSettingsModel;
 public filter : IFilter;
 public toolbarOptions: ToolbarItems[];
 @ViewChild('grid')
 public grid: GridComponent;
 public groupOptions: GroupSettingsModel;
 public templateOptionsDate: IFilterUI;
 public elem1: HTMLElement;
 public datePickerObj: DatePicker;
 subjects_urgent: any;
 formatoptions: { type: string; format: string; };
 dateFormat: string;
 sortOptions: { columns: { field: string; direction: string; }[]; };
 today = new Date();
 initialPage: { pageSize: number; };
 open_jobs_count: any;
  all_router_details: string;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;

  subject_billing_items: Object;
  job_billing_items: Object;
  app_route_billing_items: Object;

  modalRef: BsModalRef;

  constructor(    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
 viewRef: ViewContainerRef,
     ) { 

      // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));




 // Grid Options
 this.toolbarOptions = ['Search'];
 this.initialPage = { pageSize: 40 };
 this.filterOptions = {
    type: 'Menu'
 };

 
// this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
// this.groupOptions = { }; // sets auto grouping for the grid

 this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
 this.dateFormat = 'dd/MM/yyyy hh:mm a';
 this.filter = { params: { format: this.dateFormat } };
 this.sortOptions = { columns: [{ field: 'subject_billing_item_id', direction: 'Descending' } ] };


     }


        // check for changes. to load data.
   ngOnChanges(changes) {
    // this.getSubjectBillingItems(this.subject_id); // load the grid
    // this.getJobBillingItems(this.job_id);

    this.getAppRouteBillingItems(this.app_route_id);

    if (changes.subject_id) {
      // deal with asynchronous Observable result
  //   this.subject_id = changes.subject.currentValue;
  
   }

 }

 ngOnInit() {
  // this.getSubjectBillingItems(this.subject_id);
  // this.getJobBillingItems(this.job_id);

  this.getAppRouteBillingItems(this.app_route_id);

}



// Setup the SyncFusion GRID


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  // this.getSubjectBillingItems(this.subject_id);
  // this.getJobBillingItems(this.job_id);
  this.getAppRouteBillingItems(this.app_route_id);
  this.grid.refresh();
};



refreshParentGrid(){ // refresh the databutton
  this.refreshGrid();
};



getSubjectBillingItems(subject_id) {
  this._demoService.getSubjectBillingItems(subject_id).subscribe(
    data => { this.subject_billing_items = data;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


getJobBillingItems(job_id) {
  this._demoService.getJobBillingItems(job_id).subscribe(
    data => { this.job_billing_items = data;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


deleteSubjectBillingItems(subject_billing_item_id) {
  this._demoService.deleteSubjectBillingItem(subject_billing_item_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
   this.toastr.success('Subject Billing Item Removed.');
   this.refreshGrid();
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

deleteAppRouteBillingItem(app_route_billing_item_id) {
  this._demoService.deleteAppRouteBillingItem(app_route_billing_item_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
   this.toastr.success('App Route Billing Item Removed.');
   this.refreshGrid();
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}



getAppRouteBillingItems(app_route_id) {
  this._demoService.getAppRouteBillingItems(app_route_id).subscribe(
    data => { this.app_route_billing_items = data;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  // const config = { backdrop: true, ignoreBackdropClick: true };
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}





}
